import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const StyledMobileSpan = styled.span`
  ${theme.breakpoints.down('md')} {
    text-decoration: underline;
    cursor: pointer;
  }
`
